import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { style } from '@vanilla-extract/css';

// A page may import this file across the feature boundary, but no other stylesheet here.

/** The teal Flex tag tint on a Pluma Button, for a control that offers or shows the segments add-on. */
export { flexTag as flexTagButton } from './components/segments-addon-button.css';

/** Each step adds its own color, opacity and spacing. */
export const builderDowngradeEyebrowBase = style(
  {
    fontSize: themeVars['font-size'].xs,
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
  },
  'builder-downgrade-eyebrow-base',
);

/** The dark panel behind the text in both steps. Divide it per step if the two panels become different. */
export const builderDowngradeSplitContainer = style(
  {
    backgroundColor: themeVars.color['scope-action-solid-bg'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: themeVars.space['300'],
    color: themeVars.color['scope-action-solid-text'],
  },
  'builder-downgrade-split-container',
);

export const builderConfirmEyebrowInvert = style(
  [
    builderDowngradeEyebrowBase,
    {
      opacity: 0.7,
      marginBottom: themeVars.space['100'],
    },
  ],
  'offer-builder-downgrade-confirm-eyebrow-invert',
);

export const builderConfirmEyebrow = style(
  [
    builderDowngradeEyebrowBase,
    {
      color: themeVars.color['text-secondary'],
    },
  ],
  'offer-builder-downgrade-confirm-eyebrow',
);

export const builderConfirmBigHeading = style(
  {
    fontSize: themeVars['font-size'].xl,
    fontWeight: 700,
    lineHeight: 1.2,
    marginBottom: themeVars.space['200'],
  },
  'offer-builder-downgrade-confirm-big-heading',
);

export const builderConfirmLossList = style(
  {
    display: 'flex',
    flexDirection: 'column',
    gap: themeVars.space['100'],
  },
  'offer-builder-downgrade-confirm-loss-list',
);

export const builderConfirmLossItem = style(
  {
    fontSize: themeVars['font-size'].md,
  },
  'offer-builder-downgrade-confirm-loss-item',
);

const darkScheme = '[data-pluma-color-scheme="dark"] &';

export const optionBox = style(
  {
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
    borderRadius: themeVars.radius['8'],
    padding: themeVars.space['200'],
  },
  'add-funds-option-box',
);

export const optionBoxActive = style(
  {
    borderColor: themeVars.palette['teal-700'],
    background: themeVars.palette['teal-25'],
    selectors: {
      [darkScheme]: { background: themeVars.palette['teal-950'] },
    },
  },
  'add-funds-option-box-active',
);

export const activeDivider = style(
  {
    backgroundColor: themeVars.palette['teal-100'],
    selectors: {
      [darkScheme]: { backgroundColor: themeVars.palette['teal-900'] },
    },
  },
  'add-funds-active-divider',
);
